export default __webpack_public_path__ + "static/media/logo-dark.78a56341.svg";